var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttachmentPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.499,
    height: 7.52,
    viewBox: "0 0 7.499 7.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M7.315-1.711a.563.563,0,0,1,0,.8.563.563,0,0,1-.8,0L3.75-3.705.961-.916a.563.563,0,0,1-.8,0,.563.563,0,0,1,0-.8L2.955-4.5.165-7.31a.563.563,0,0,1,0-.8.563.563,0,0,1,.8,0L3.75-5.295,6.539-8.084a.563.563,0,0,1,.8,0,.563.563,0,0,1,0,.8L4.545-4.5Z",
    transform: "translate(0 8.27)",
    fill: "#444a5e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentPlus);
export default __webpack_public_path__ + "static/media/attachment_plus.a1457c69953d2a34f0ccdca53b704b44.svg";
export { ForwardRef as ReactComponent };